import React, { CSSProperties } from 'react'

import { ServiceFeeDetail } from '@/components/misc/ServiceFeesTable/ServiceFeesTableRows'
import { TableHead, TableRow } from '@/components/ui/table'
import { useIsCompanyUser } from '@/hooks/useIsCompanyUser'
import serviceFeeService from '@/lib/services/serviceFeeService'
import { cn } from '@/lib/utils'
import { CommercialAgreementTypeOption } from '@/redux/slices/commercialAgreementsForm'
interface Props {
  serviceFees: ServiceFeeDetail[]
  showExampleColumn: boolean
  showActionsColumn?: boolean
  isRecommendedPartnerTerms?: boolean
  agreementType: CommercialAgreementTypeOption
  isPreviewLetter: boolean
}

export interface ServiceFeeTableHeading {
  label: string
  className?: string
  style: CSSProperties
}

const ServiceFeesTableHeaders: React.FC<Props> = ({
  serviceFees,
  showExampleColumn,
  showActionsColumn = false,
  isRecommendedPartnerTerms,
  agreementType,
  isPreviewLetter,
}) => {
  const isCompanyUser = useIsCompanyUser()
  serviceFeeService.validateServiceFeesOrFail(serviceFees)

  const tableHeaders = serviceFeeService.getTableHeaders({
    serviceFees,
    showExampleColumn,
    showActionsColumn,
    agreementType,
    isRecommendedPartnerTerms,
    isCompanyUser,
    isPreviewLetter,
  })

  return (
    <TableRow>
      {tableHeaders.map((header, index) => (
        <TableHead
          key={index}
          className={cn('align-top font-medium normal-case!', header.className)}
          style={header.style}
        >
          {header.label}
        </TableHead>
      ))}
    </TableRow>
  )
}

export default ServiceFeesTableHeaders
